export default __webpack_public_path__ + "static/media/power-up-icon.3482a4c3.svg";